import ng from 'angular';

export class MensagemErroInputController implements ng.IController {
  static $inject = ['$element'];

  constructor(private $element: JQLite) {}

}
